import {memo} from 'react';

interface Props {
  icon: string;
  count: number;
}

const ProductIcon = memo(({icon, count}: Props) => {
  if (!icon) return null;

  return (
    <div className="relative w-fit shrink-0">
      <img src={icon} alt="order-icon" className="object-cover w-10 h-10" />
      <span className="absolute flex items-center justify-center w-5 h-5 text-sm font-medium text-gray-800 rounded-full bg-green-50 -top-1 -left-2">
        {count}
      </span>
    </div>
  );
});

export default ProductIcon;
